import axios from "axios";

window.axios = axios;
window.axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";

// API configuration utilities
export const apiConfig = {
  setBaseUrl(url) {
    axios.defaults.baseURL = url;
  },
  setAuthToken(token) {
    if (token) {
      axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
    } else {
      delete axios.defaults.headers.common["Authorization"];
    }
  },
};

// Initialize token from localStorage if available
const userToken = localStorage.getItem("token");
if (userToken) {
  apiConfig.setAuthToken(userToken);
}

export { axios };
